import {defineStore} from 'pinia';
import {ref, computed} from 'vue';
import {send} from '@/composables/apiClient';

export const useAnnouncementsStore = defineStore('announcements', () => {
    const messages = ref([]);
    const loading = ref(false);

    const unreadCount = computed(() => messages.value.filter(m => !m.is_read).length);

    async function fetchMessages() {
        loading.value = true;
        try {
            const response = await send('get', 'app-messages');
            messages.value = response.data.data ?? [];
        } catch {
            // non-fatal; badge stays at last known count
        } finally {
            loading.value = false;
        }
    }

    async function markRead(id) {
        const msg = messages.value.find(m => m.id === id);
        if (!msg || msg.is_read) return;
        msg.is_read = true;
        try {
            await send('post', `app-messages/${id}/read`);
        } catch {
            msg.is_read = false;
        }
    }

    return {messages, loading, unreadCount, fetchMessages, markRead};
});
